import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-header-views',
	templateUrl: './header-views.component.html',
	styleUrls: ['./header-views.component.scss'],
})
export class HeaderViewsComponent implements OnInit {
	@Input() title = '';
	@Input() textButton = '';
	@Input() hoverButton = '';
	@Output() actionButton = new EventEmitter<boolean>();
	constructor() {}

	ngOnInit(): void {}

	action() {
		this.actionButton.emit(true);
	}
}
